/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_Th_CategoryInputs */

const tr_cerez_s3_th_category = /** @type {(inputs: Cerez_S3_Th_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const en_cerez_s3_th_category = /** @type {(inputs: Cerez_S3_Th_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const de_cerez_s3_th_category = /** @type {(inputs: Cerez_S3_Th_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const ru_cerez_s3_th_category = /** @type {(inputs: Cerez_S3_Th_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Cerez_S3_Th_CategoryInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_th_category = /** @type {((inputs?: Cerez_S3_Th_CategoryInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_Th_CategoryInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_th_category(inputs)
	if (locale === "de") return de_cerez_s3_th_category(inputs)
	if (locale === "ru") return ru_cerez_s3_th_category(inputs)
	return tr_cerez_s3_th_category(inputs)
});